import React, { useContext, useRef } from 'react'
import useClosable from '../../../hooks/useClosable'
import CustomerCart from '../../CustomerCart'
import Drawer from '../../Drawer'
import Image from '../../Image'
import cart from '../../../assets/nav/cart.png'
import Typography from '../../Typography'
import { CustomerContext } from '../../../contexts/CustomerContext'
import { pluralize } from '../../../utils/functions'
import styles from './NavCart.module.sass'
import close from '../../../assets/nav/close.png'

const NavCart = () => {
  const ref = useRef(null)
  const [open, toggle] = useClosable(ref)
  const { customer } = useContext(CustomerContext)

  const numItems = customer.cart ? customer.cart.orderPackages.reduce((acc, cur) => acc + 1 + cur.extras.length, 0) : 0

  return (
    <div ref={ref} className={styles.navCart}>
      <Image src={cart} classes={styles.icon} onClick={toggle} />
      <Drawer open={open} classes={styles.drawer}>
        <div className={styles.header}>
          <Typography tag='h3' weight={600}>{pluralize('item', numItems)}</Typography>
            <Image src={close} classes={styles.closeIcon} onClick={toggle} />
        </div>
        {open && <CustomerCart classes={styles.cart} spinnerColor='blue' showCheckoutLink />}
      </Drawer>
    </div>
  )
}

export default NavCart
